import { render } from "./manualOcr.vue?vue&type=template&id=6f41ec5b&scoped=true"
import script from "./manualOcr.vue?vue&type=script&lang=js"
export * from "./manualOcr.vue?vue&type=script&lang=js"

import "./manualOcr.vue?vue&type=style&index=0&id=6f41ec5b&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f41ec5b"]])

export default __exports__